const options = [
  {
    dicId:10,
    cnName:'10-项目管理文件夹'
  },
  {
    dicId:11,
    cnName:'11-专业文件夹'
  },
  {
    dicId:12,
    cnName:'12-子项'
  },
  {
    dicId:14,
    cnName:'14-中心文件夹'
  },
  {
    dicId:15,
    cnName:'15-提资准备区文件夹'
  },
  {
    dicId:16,
    cnName:'16-三维图纸目录文件夹'
  },
  {
    dicId:17,
    cnName:'17-成品区文件夹子级文件夹'
  },
  {
    dicId:18,
    cnName:'18-三维图纸目录文件夹下自建文件夹'
  },
  {
    dicId:19,
    cnName:'19-提资准备区文件夹下自建文件夹'
  },
  {
    dicId:20,
    cnName:'20-项目管理文件夹下自建文件夹'
  },
  {
    dicId:21,
    cnName:'21-设计区子项文件夹下自建文件夹'
  },
  {
    dicId:22,
    cnName:'22-提资区子项文件夹下自建文件夹'
  },
  {
    dicId:23,
    cnName:'23-提资区子项文件夹'
  },
  {
    dicId:24,
    cnName:'24-阶段文件夹'
  },
  {
    dicId:26,
    cnName:'26-成品区下无子项的第一级文件夹'
  },
  {
    dicId:27,
    cnName:'27-成品区子项文件夹的父级'
  },
  {
    dicId:28,
    cnName:'28-成品区下施工图'
  },
  {
    dicId:29,
    cnName:'29-成品区下子项'
  },
  {
    dicId:30,
    cnName:'30-成品区下专业'
  },
  {
    dicId:31,
    cnName:'31-文件格式PDF/DWG'
  },
  {
    dicId:32,
    cnName:'32-成品区修改图下专业'
  },
  {
    dicId:33,
    cnName:'33-成品区修改图下文件格式PDF/DWG'
  },
  {
    dicId:34,
    cnName:'34-施工图子项下的上传修改图文件夹'
  },
  {
    dicId:35,
    cnName:'35-成品区下无子项的专业文件夹'
  },
  {
    dicId:51,
    cnName:'51-图纸集'
  },
  {
    dicId:52,
    cnName:'52-图纸集子级'
  },
  {
    dicId:54,
    cnName:'54-完成总校文件'
  },
  {
    dicId:55,
    cnName:'55-完成总校文件下专业文件夹'
  },
  {
    dicId:99,
    cnName:'99-默认文件夹'
  },
  {
    dicId:101,
    cnName:'101-设计区文件夹类型'
  },
  {
    dicId:103,
    cnName:'103-成品区文件夹'
  },
  {
    dicId:104,
    cnName:'104-成品区下的动态目录的父级'
  },
  {
    dicId:105,
    cnName:'105-成品区下的动态目录的订货文件'
  }
]
export default options;